import * as React from "react";
import styled from "styled-components";
import * as colors from "../settings/colors";
import Icon from "./Icon";

const Label = styled.span`
  display: block;
  font-size: 14px;
  line-height: 24px;
  color: ${colors.TAB_TEXT};
  margin-left: 5px;
`;

const LabelWithIconWrapper = styled.div`
  display: inline-flex;
  align-items: center;
`;

const LabelWithIcon = ({ icon, children, ...otherProps }) => (
  <LabelWithIconWrapper {...otherProps}>
    <Icon icon={icon} style={{ fill: colors.TAB_TEXT }} />
    <Label>{children}</Label>
  </LabelWithIconWrapper>
);

export default LabelWithIcon;



// WEBPACK FOOTER //
// ./src/components/LabelWithIcon.js